export default {"src":"/_next/static/media/3.054a7ff9.svg","height":130,"width":120,"blurWidth":0,"blurHeight":0};